import { parseIsoAsWallClock } from '@/src/utils/dateUtil'

/**
 * This is used to ensure that the datapoints in the procurement charts are not shifted by a day, because the backend
 * already serve the data point time buckets using the proper german timezone.
 * If we decide to make the frontend aware of the timezone of the company, then we should consider removing/refactoring this method.
 * Example:
 * The backend returns: 2026-01-01T00:00:00+01:00
 * The frontend is running from a UTC+0 location
 * When making a Date instance, it will be considered 2025-12-31.
 * This makes sure that the date string becomes 2026-01-01 00:00:00
 */
export const normalizeDataPointTimestamp = <T extends { timestampStart: string }>(dataPoint: T): T => ({
  ...dataPoint,
  timestampStart: parseIsoAsWallClock(dataPoint.timestampStart).toISOString(),
})
